import React from "react";
import Layout from "../../Layout";
import { H2 } from "../../Common/Typography";
import { BodyContent, Container, BodyWhitePattern } from "../../Common/GridSystem";
import { BackCheck } from "../../Common/BackNav";
import { Formik, Form } from "formik";
import { clientManagementValidation } from "../../../validations/authValidation";
import FormTextField from "../../Common/FormElements/FormTextField";
import { PrimaryButton } from "../../Common/Buttons/PrimaryButton";
import AutoCompleteFormik from "../../Common/FormElements/AutoCompleteFormik";
import AutoFilterLocal from "../../Common/FormElements/AutoFilterLocal";
import ChipList from "../../Common/Others/ChipList";
import { SecondaryButton } from "../../Common/Buttons/SecondaryButton";
import { CheckSameArray } from "../../utils";
import useClientManagement from "./useClientManagement";
import styles from "./ClientManagement.module.scss";
import { Modes } from "../../../enums/Modes";
import text from "../../../locale.en.json";

export default ({ ...props }) => {
  const { mode, id } = props;
  const {
    handleCheckBack,
    clientOrgs,
    initValue,
    formikRef,
    formSubmit,
    clientInstanceRegion,
    deleteTrigger,
    sourceMenu,
    handleSearch,
    removeChip,
    subSectors,
    handleSelectAll,
    functions,
    contentProviders,
  } = useClientManagement({ mode, id });
  return (
    <Layout>
      <H2>{mode === Modes.ADD ? text.client.createNewClient : text.client.manageClientAccount}</H2>
      <BodyContent>
        <Container>
          <BackCheck handleCheckBack={handleCheckBack} />
          <BodyWhitePattern>
            {(mode === Modes.EDIT && clientOrgs?.length > 0) || mode === Modes.ADD ? (
              <Formik
                enableReinitialize={true}
                initialValues={initValue}
                innerRef={formikRef}
                validationSchema={clientManagementValidation}
                onSubmit={formSubmit}
              >
                {({ values, setFieldValue, setFieldTouched, setTouched }) => {
                  return (
                    <Form className={styles.formBlock}>
                      <div className={styles.clientFormLeft}>
                        <FormTextField
                          placeholder=""
                          name="clientName"
                          type="text"
                          label={text.client.clientName}
                          setVal={setFieldValue}
                          setTouched={setFieldTouched}
                        />
                        <FormTextField
                          placeholder={text.client.domainForGoogleSignInPlaceHolder}
                          name="clientDomain"
                          type="text"
                          label={text.client.domainForGoogleSignIn}
                          helperText={text.client.domainForGoogleSignInHelperText}
                          setVal={setFieldValue}
                          setTouched={setFieldTouched}
                        />
                        <FormTextField
                          placeholder={text.client.disprzInstanceNamePlaceHolder}
                          name="disprzInstanceName"
                          type="text"
                          label={text.client.disprzInstanceName}
                          setVal={setFieldValue}
                          setTouched={setFieldTouched}
                        />
                        {(mode === Modes.EDIT && values.region !== undefined) ||
                        mode === Modes.ADD ? (
                          <AutoCompleteFormik
                            list={clientInstanceRegion}
                            filterLabel="label"
                            name="region"
                            label={text.client.disprzRegion}
                            style={{
                              padding: "0px 0px 0px 0px",
                              width: "100%",
                            }}
                            placeholder={text.client.disprzRegionPlaceHolder}
                          />
                        ) : null}
                        <PrimaryButton type="submit">
                          {mode === Modes.EDIT ? text.client.updateClient : text.client.createClient}
                        </PrimaryButton>
                        {mode === Modes.EDIT && (
                          <SecondaryButton
                            onClick={deleteTrigger}
                            style={{ marginLeft: 15 }}
                          >
                            {text.client.deleteClient}
                          </SecondaryButton>
                        )}
                      </div>
                      <div className={styles.clientFormRight}>
                        <div className={styles.dropDownRow}>
                          {(mode === Modes.EDIT &&
                            values.orgGrowthStageId !== undefined) ||
                          mode === Modes.ADD ? (
                            <AutoCompleteFormik
                              list={clientOrgs}
                              filterLabel="label"
                              name="orgGrowthStageId"
                              label={text.client.orgGrowthStage}
                              style={{
                                padding: "0px 0px 10px 0px",
                                width: "340px",
                              }}
                              placeholder={text.client.orgGrowthStagePlaceHolder}
                            />
                          ) : null}
                        </div>
                        <div className={styles.dropDownRow}>
                          <AutoFilterLocal
                            list={sourceMenu}
                            filterLabel="label"
                            label={text.client.source}
                            style={{
                              padding: "0px 0px 20px 0px",
                              width: "340px",
                            }}
                            placeholder={text.client.sourcePlaceHolder}
                            optionChange={(item, reason) =>
                              handleSearch(
                                item,
                                reason,
                                values?.sourceIdList,
                                "sourceIdList",
                                setFieldValue,
                                setTouched,
                                "multiple"
                              )
                            }
                            value=""
                            inputValue=""
                          />
                          {!!values?.sourceIdList && (
                            <ChipList
                              list={values.sourceIdList}
                              optionLabel="label"
                              onDelete={(item) =>
                                removeChip(
                                  item,
                                  values.sourceIdList,
                                  "sourceIdList",
                                  setFieldValue,
                                  values
                                )
                              }
                            />
                          )}
                        </div>
                        {!!values?.proficiencySchemeName && (
                          <FormTextField
                            placeholder=""
                            name="proficiencySchemeName"
                            type="text"
                            label={text.client.proficiencyScheme}
                            disabled={true}
                            style={{ width: "fit-content" }}
                          />
                        )}
                        <div className={styles.dropDownRow}>
                          <AutoFilterLocal
                            list={subSectors}
                            filterLabel="label"
                            label={text.client.associatedIndustries}
                            style={{
                              padding: "0px 0px 20px 0px",
                              width: "340px",
                            }}
                            placeholder={text.client.associatedIndustriesPlaceHolder}
                            optionChange={(item, reason) =>
                              handleSearch(
                                item,
                                reason,
                                values?.subSectorIdList,
                                "subSectorIdList",
                                setFieldValue,
                                setTouched,
                                "multiple"
                              )
                            }
                            value=""
                            inputValue=""
                            selectAll={
                              (subSectors?.length > 0 &&
                                !!values.sourceIdList?.length) ||
                              false
                            }
                            unselectAll={CheckSameArray(
                              subSectors,
                              values?.subSectorIdList
                            )}
                            selectAllClick={() =>
                              handleSelectAll(
                                subSectors,
                                CheckSameArray(
                                  subSectors,
                                  values?.subSectorIdList
                                ),
                                "subSectorIdList",
                                setFieldValue
                              )
                            }
                            disabled={!values.sourceIdList?.length}
                          />
                          {!!values?.subSectorIdList && (
                            <ChipList
                              list={values.subSectorIdList}
                              optionLabel="label"
                              onDelete={(item) =>
                                removeChip(
                                  item,
                                  values.subSectorIdList,
                                  "subSectorIdList",
                                  setFieldValue,
                                  values
                                )
                              }
                            />
                          )}
                        </div>
                        <div className={styles.dropDownRow}>
                          <AutoFilterLocal
                            list={functions}
                            filterLabel="label"
                            label={text.client.associatedFunctions}
                            style={{
                              padding: "0px 0px 20px 0px",
                              width: "340px",
                            }}
                            placeholder={text.client.associatedFunctionsPlaceHolder}
                            optionChange={(item, reason) =>
                              handleSearch(
                                item,
                                reason,
                                values?.functionIdList,
                                "functionIdList",
                                setFieldValue,
                                setTouched,
                                "multiple"
                              )
                            }
                            value=""
                            inputValue=""
                            selectAll={
                              functions?.length > 0 &&
                              !!values.sourceIdList?.length
                            }
                            unselectAll={CheckSameArray(
                              functions,
                              values?.functionIdList
                            )}
                            selectAllClick={() =>
                              handleSelectAll(
                                functions,
                                CheckSameArray(
                                  functions,
                                  values?.functionIdList
                                ),
                                "functionIdList",
                                setFieldValue
                              )
                            }
                            disabled={!values.sourceIdList?.length}
                          />
                          {!!values?.functionIdList && (
                            <ChipList
                              list={values.functionIdList}
                              optionLabel="label"
                              onDelete={(item) =>
                                removeChip(
                                  item,
                                  values.functionIdList,
                                  "functionIdList",
                                  setFieldValue,
                                  values
                                )
                              }
                            />
                          )}
                        </div>
                        <div className={styles.dropDownRow}>
                          <AutoFilterLocal
                            list={contentProviders}
                            filterLabel="label"
                            label={text.client.contentProviders}
                            style={{
                              padding: "0px 0px 20px 0px",
                              width: "340px",
                            }}
                            placeholder={text.client.contentProvidersPlaceHolder}
                            optionChange={(item, reason) =>
                              handleSearch(
                                item,
                                reason,
                                values?.contentProviderList,
                                "contentProviderList",
                                setFieldValue,
                                setTouched,
                                "multiple"
                              )
                            }
                            value=""
                            inputValue=""
                            selectAll={true}
                            unselectAll={
                              contentProviders?.length ===
                              values?.contentProviderList?.length
                            }
                            selectAllClick={() =>
                              handleSelectAll(
                                contentProviders,
                                contentProviders?.length ===
                                  values?.contentProviderList?.length,
                                "contentProviderList",
                                setFieldValue
                              )
                            }
                          />
                          {!!values?.contentProviderList && (
                            <ChipList
                              list={values.contentProviderList}
                              optionLabel="label"
                              onDelete={(item) =>
                                removeChip(
                                  item,
                                  values.contentProviderList,
                                  "contentProviderList",
                                  setFieldValue,
                                  values
                                )
                              }
                            />
                          )}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            ) : (
              <div style={{ minHeight: 500 }}>&nbsp;</div>
            )}
          </BodyWhitePattern>
        </Container>
      </BodyContent>
    </Layout>
  );
};
